<template>
  <b-container id="resultats_container">
    <b-row>
      <b-col md="12">
        <div class="content_container">
          <Loading v-if="$store.state.loading"></Loading>
          <transition name="fade">
            <TableauResultats v-if="$store.state.module.resultats && !$store.state.loading" :epreuve="$store.state.module.resultats" @fetchCourseResultats="fetchCourseResultats"></TableauResultats>
          </transition>
          <div v-if="!$store.state.module.resultats && !$store.state.loading">
            <h3>{{ $t("tab_resultats.erreur") }}</h3>
            <router-link to="courses"
              ><b-button class="inline-btn">{{ $t("retour") }}</b-button></router-link
            >
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import TableauResultats from "@/components/Resultats_tab/TableauResultats.vue";
import Loading from "@/components/Loading.vue";
export default {
  components: { TableauResultats, Loading },
  data() {
    return {};
  },
  methods: {
    fetchCourseResultats(c) {
      var _this = this;

      axios.get("https://sportips.fr/api/v1/resultats/endpoints/public/epreuve/get.php?id_module=" + this.$store.state.module.id + "&course=" + encodeURIComponent(c)).then(function (response) {
        response.data.fields.pop();
        _this.$store.commit("setResultats", response.data);
        _this.$forceUpdate();
      });
    },
  },
  mounted() {
    this.$store.commit("setLoading");
    var course = "";
    if (this.$route.params.course && this.$route.params.course != "") {
      course = this.$route.params.course;
    }
    var _this = this;
    axios.get("https://sportips.fr/api/v1/resultats/endpoints/public/epreuve/get.php?id_module=" + this.$store.state.module.id + "&course=" + encodeURIComponent(course)).then(function (response) {
      if (response.data.message) {
        _this.$store.commit("unsetLoading");
      } else {
        response.data.fields.pop();
        _this.$store.commit("setResultats", response.data);
        _this.$store.commit("unsetLoading");
        _this.$forceUpdate();
      }
    });
  },
};
</script>

<style lang="sass" scoped>
</style>